import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import InputField from "../Components/Login/InputField";
import LeftWindowtext from "../Components/Login/LeftWindowtext";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { environmentDetails } from "../environment/environment";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isUserLoggedIn = useSelector((state) => state.authReducer.data);
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const getColorTheme = JSON.parse(localStorage.getItem("colors")) || [];
  const primaryColor = getColorTheme[0]?.primaryColor || "#041c44";
  const secondaryColor = getColorTheme[0]?.secondaryColor || "#ff9900";

  useEffect(() => {
    const sessionExpired = localStorage.getItem("sessionExpired");
    if (sessionExpired) {
      setIsSessionExpired(true);
      localStorage.removeItem("sessionExpired");
      setTimeout(() => {
        setIsSessionExpired(false);
        localStorage.clear();
      }, 2000);
    }
    if (isUserLoggedIn && location.pathname === "/") {
      const prevPath = sessionStorage.getItem("previousPath");
      navigate(prevPath || "/openings_table");
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          Width: "100%",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LeftWindowtext image={`${environmentDetails.logoUrl}`} />

        <InputField
          isSessionExpired={isSessionExpired}
          setIsSessionExpired={setIsSessionExpired}
        />
      </Box>
    </>
  );
};

export default Login;
